import type { InputBaseProps } from "@mui/material";
import cx from "classnames";
import { SearchIcon } from "@ui-icons";
import type { InputFieldSize } from "../sharedInputTypes";
import { StyledInputBase } from "./SearchInput.styled";

export interface SearchInputProps extends Omit<InputBaseProps, "size"> {
  size?: InputFieldSize;
  ref?: React.Ref<HTMLInputElement>;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  /** PostHog autocapture action name for the search field (default `search`). */
  phAction?: string;
}

const SearchInput = ({
  placeholder = "Search…",
  className,
  size = "medium",
  ref,
  startAdornment = <SearchIcon color="action" />,
  endAdornment,
  inputProps,
  phAction = "search",
  ...props
}: SearchInputProps) => (
  <StyledInputBase
    className={cx(className)}
    $size={size}
    startAdornment={startAdornment}
    endAdornment={endAdornment}
    placeholder={placeholder}
    inputProps={{
      "aria-label": "search",
      type: "search",
      "data-test-id": "search-input",
      "data-ph-capture-attribute-action": phAction,
      ...inputProps,
    }}
    ref={ref}
    {...props}
  />
);

export default SearchInput;
